import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { ActionButton } from '@/components/custom-ui/action-button';
import { FloatingActionBar } from '@/components/custom-ui/FloatingActionBar';

interface StepNavButtonsProps {
    canGoBack: boolean;
    onGoBack: () => void;
    onNext: () => void;
    nextLabel: string;
    nextDisabled?: boolean;
}

export const StepNavButtons: React.FC<StepNavButtonsProps> = ({
    canGoBack,
    onGoBack,
    onNext,
    nextLabel,
    nextDisabled,
}) => {
    return (
        <FloatingActionBar>
            {canGoBack && (
                <button
                    onClick={onGoBack}
                    className="flex items-center gap-2 px-5 py-2.5 rounded-xl border-2 border-gray-200 text-gray-700 font-semibold text-sm hover:bg-gray-50 transition-colors bg-white"
                >
                    <ArrowLeft className="w-4 h-4" />
                    Tillbaka
                </button>
            )}
            <ActionButton
                className="flex-1"
                onClick={onNext}
                disabled={nextDisabled}
            >
                {nextLabel}
            </ActionButton>
        </FloatingActionBar>
    );
};
